module.exports = __webpack_public_path__ + "cad35652b250637425d8b60d99f57e6a.png";